(() => {
  if (customElements.get('aven-contour-fit')) return;
  class AvenContourFit extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.aven-contour-fit__trigger');
      this.closeButton = this.querySelector('.aven-contour-fit__close');
      if (!this.dialog || !this.trigger || !this.closeButton) return;
      this.trigger.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        const returnTarget = this.opener?.isConnected ? this.opener : this.trigger;
        returnTarget.focus({ preventScroll: true });
      });
    }
    open(opener = this.trigger) {
      if (this.dialog.open) return;
      this.opener = opener;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.closeButton.focus();
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
    }
  }
  customElements.define('aven-contour-fit', AvenContourFit);
  // Keep one chart and route the set-heading link to its existing dialog.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-contour-fit-open]');
    if (!opener) return;
    const chart = document.getElementById(opener.dataset.contourFitOpen);
    if (chart instanceof AvenContourFit && chart.dialog) chart.open(opener);
  });
})();
